module.exports = __webpack_public_path__ + "img/01_full.0eae18de.jpg";